import type * as core from '../../../../../../../core'

/**
 * At the root level (no policyAreaId) the page is titled "Policy Explorer".
 * Inside an area, it is titled with the area's name, with a breadcrumb back
 * to the root level.
 */
export const query: core.mosaic.Page.Query = {
  selection: {
    if: [
      [
        {
          '=': [{ '@$': 'policyAreaId' }, null],
        },
        {
          '{}': {
            title: 'Policy Explorer',
          },
        },
      ],
      {
        '@': 'areaLens',
      },
    ],
  },
  subqueries: {
    areaLens: {
      filter: {
        '=': [{ '@.': '!id' }, { '@$': 'policyAreaId' }],
      },
      target: 'ent:!policies:!policy_area',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          breadcrumbs: {
            '[]': [
              {
                '{}': {
                  goto: {
                    '{}': {
                      variables: {
                        '{}': {},
                      },
                      navigationId: 'policy-explorer',
                    },
                  },
                  name: 'Policy Explorer',
                },
              },
            ],
          },
        },
      },
    },
  },
  variables: {
    policyAreaId: null,
  },
}
